import {getDialogContent} from "../../common/api";
import {replaceHtml} from "../../common/helper";

class BuhaOverlay extends HTMLElement {
  connectedCallback() {
    this.declareElements();
    this.declareAndRegisterListeners();
  }

  declareElements() {
    this.dialogParent = this.closest("[dialogParent]");
    this.overlay = this.querySelector(".filialeBearbeitenOverlay");
    this.openFrom = this.overlay.closest("div[open-dialog-from]").getAttribute("open-dialog-from");
    if(this.overlay.closest("div[artikelnummer]")) {
      this.artikelnummer = this.overlay.closest("div[artikelnummer]").getAttribute("artikelnummer");
    }
    else {
      this.artikelnummer = "";
    }
  }

  async declareAndRegisterListeners() {
    this.dialogParent.addEventListener("click", async (event) => {
      await this.handleClick(event, this.artikelnummer);
    });
  }

  async handleClick(event, artikelnummer) {
    if (event.target.closest(".filiale-aendern")) {
      event.preventDefault();
      if (this.overlay.childNodes.length !== 0) {
        this.overlay.showModal();
        return;
      }

      let retries = 3;
      let success = false;
      while (retries-- > 0 && !(success = await loadAndShowDialog(artikelnummer, this.overlay, this.openFrom))) {}
    }
  }
}

export async function loadAndShowDialog(artikelnummer, dialog, openFrom) {
  try {
    const response = await getDialogContent(artikelnummer, openFrom);
    const html = await response.text();
    replaceHtml(dialog, html);
    dialog.showModal();
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
}

if (!customElements.get("buha-overlay")) {
  customElements.define("buha-overlay", BuhaOverlay);
}